import { Component } from "react";
import { connect } from "react-redux";

import { addSettings } from "../../../actions";
import {
  getClientFormWithSubmissions,
  viewGeneralSubmission,
  deleteSubmission,
  sendFormEmail,
  allClientRejections,
  stopAIAgent,
  attachSharelinks,
  fetchAttachedSharelinks,
  getAgentTwilioVerificationData,
  makeOutboundConnection,
  attachAgentNumberAPI,
} from "./../../../config/agent_forms_api_calls";
import $ from "jquery";
import { APP_LIVE_URL } from "../../../config/config";
import DataTableExtended from "../../../components/Tables/DataTableExtended";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Link from "@material-ui/core/Link";
import HomeIcon from "@material-ui/icons/Home";
import Typography from "@material-ui/core/Typography";
import FormRenderer from "../../../components/formRender";
import { TableLoader } from "../../../components/ContentLoaders/newLoaders/TableLoader";
import { FormLoader } from "../../../components/ContentLoaders/newLoaders/Form";
import MsaWarning from "../ExtraComponents/MsaWarning";
import SettingsError from "../ExtraComponents/SettingsError";
import PageTitle from "../ExtraComponents/PageTitle";
import HelperClass from "./../../../config/helperClass";
import dateFormat from "dateformat";
import Select from "react-select";
import LiveKitPopup from "../../../components/Reseller/LiveKitPopup";
import axios from "axios";

const auth = new HelperClass();

class FormSubmit extends Component {
  constructor() {
    super();

    this.state = {
      tableData: [],
      tableDataSingle: [],
      serviceData: [],
      tableLoaderListing: true,
      tableLoader: true,
      errorMessage: "",
      successMessage: "",
      showModal: false,
      modalContent: null,
      formAccNo: "",
      successMessageSaveResponse: "",
      errorMessageSaveResponse: "",
      form_accountno: "",
      form_token: "",
      form_token_submission: "",
      formData: "",
      form_title: "",
      form_desc: "",
      totalSubmissions: [],
      activeTab: "total_submissions",
      assignedLoader: false,
      errorMessageTotals: "",
      errorMessageTotalsTitle: "",
      emailErrorMessage: "",
      emailErrorMessageTitle: "",
      emailSuccessMessage: "",
      total_completed: 0,
      total_not_completed: 0,
      submission_id: "",
      allow_multiple: 0,
      emailto: "",
      emailtoname: "",
      emailsubject: "",
      emailcontent: "",
      email_button: false,
      extra_files: [],
      rejectGeneralErrorMessage: "",
      rejectGeneralSuccessMessage: "",
      reject_general_button: false,
      reject_general_reason: "",

      allGeneralRejectionsListing: [],
      rejectionLoader: false,

      showIframeModal: false,
      iframeStopped: false,
      showAgentActionModal: false,
      iframeUrl: "",
      stopUrl: "",
      agentPid: "",
      agentID: "",
      agentRoom: "",
      agentSharelinks: [],
      selectedSharelinks: [],
      isStoppingAgent: false,
      responseMessage: "",
      disabled: false,
      isProcessingAttach: false,
      successMessageAttach: "",
      errorMessageAttach: "",
      showAgentPopup: false,
      isLaunching: false,
      isStoppingAgent: false,
      responseMessage: "",
      clientList: [], // dropdown options [{label, value}]
      selectedClients: [],
      phoneId: [],
      showSharelinks: false,
      showClients: false,
      showTwilioNumbers: false,
      selectedTwilioSid: "",
      aiAgent: null,
      widgetLinkCopied: false,
      twilioJsonCopied: false,
      isConnecting: false,
      connectionSuccess: false,
      connectionError: "",
      showRemoveModal: false,
      isRemovingNumber: false,
      successMessageAttach: "",
      errorMessageAttach: "",

      isProcessingPopup: false,
      popupMessage: null,
      agentPid: null,

      currentAgentId: null, // Fetched from backend (popup_active=1)
      currentAgentRoom: null,
      currentUserForm: "No",
      currentAgentName: "AI Agent",
      currentTelephonyToken: null,
      errorMessageDelete: "",
      successMessageDelte: "",
      generalColumnServices: [
        {
          name: "index",
          label: "#",
        },
        {
          name: "id",
          label: "Progres / ",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{this.format_client_title(value, tableMeta)}</div>;
            },
          },
        },
        {
          name: "submitter_name",
          label: "Submitted By",
        },
        {
          name: "is_submitted",
          label: "Submitted",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{this.format_submitted(value)}</div>;
            },
          },
        },
        {
          name: "submitted_on",
          label: "Submitted On",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{this.format_date(value)}</div>;
            },
          },
        },
        {
          name: "sent_by_email",
          label: "Sent By",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{value ? value : "---"}</div>;
            },
          },
        },
        {
          name: "pdf_name",
          label: "View PDF",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return (
                <div>{this.format_download_general(value, tableMeta)}</div>
              );
            },
          },
        },
        {
          name: "submission_status",
          label: "Status",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return (
                <div>{this.format_submission_status(value, tableMeta)}</div>
              );
            },
          },
        },
        {
          name: "conversational_ai_url",
          label: "Agent Configuration",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{this.format_agent_link(value, tableMeta)}</div>;
            },
          },
        },
        {
          name: "id",
          label: "Actions",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              const formAccNo = tableMeta.rowData[10] + "/" + tableMeta.rowData[11];
              const isNotSubmitted = tableMeta.rowData[3] === 0;
              const isDraft = tableMeta.rowData[3] === 1;
              const isLinkOnly = tableMeta.rowData[12] === 1;
              const externalLink = tableMeta.rowData[13];

              const btnStyle = { padding: 0, backgroundColor: "transparent", outline: "none" };

              return (
                <div className="d-flex align-items-center" style={{ gap: 6 }}>
                  {/* View Details — hidden for link-only forms */}
                  {tableMeta.rowData[12] !== 1 && (
                    <Tooltip title="View Details" arrow>
                      <IconButton size="small" onClick={() => this.viewGeneralSubmission(value)} style={btnStyle}>
                        <em className="icon ni ni-card-view" style={{ fontSize: 20, color: "#09c2de" }}></em>
                      </IconButton>
                    </Tooltip>
                  )}

                  {/* Submit Form OR Link Only (not submitted) */}
                  {isNotSubmitted && (
                    isLinkOnly ? (
                      <Tooltip title="Open external link in a new tab" arrow>
                        <IconButton size="small" component="a" href={externalLink} target="_blank" style={btnStyle}>
                          <em className="icon ni ni-external" style={{ fontSize: 20, color: "#f4bd0e" }}></em>
                        </IconButton>
                      </Tooltip>
                    ) : (
                      <Tooltip title="Submit Form" arrow>
                        <IconButton
                          size="small"
                          onClick={() => {
                            sessionStorage.removeItem("skipResetDefaults");
                            sessionStorage.removeItem("formInitialized");
                            this.addMenuHistory("/agent_form_submit/" + formAccNo);
                          }}
                          style={btnStyle}
                        >
                          <em className="icon ni ni-edit" style={{ fontSize: 20, color: "#6576ff" }}></em>
                        </IconButton>
                      </Tooltip>
                    )
                  )}

                  {/* Edit Form (draft) */}
                  {isDraft && (
                    <Tooltip title="Edit Form" arrow>
                      <IconButton
                        size="small"
                        onClick={() => {
                          sessionStorage.removeItem("skipResetDefaults");
                          sessionStorage.removeItem("formInitialized");
                          this.addMenuHistory("/agent_form_submit/" + formAccNo);
                        }}
                        style={btnStyle}
                      >
                        <em className="icon ni ni-edit" style={{ fontSize: 20, color: "#6576ff" }}></em>
                      </IconButton>
                    </Tooltip>
                  )}

                  {/* View Rejections */}
                  <Tooltip title="View Rejections" arrow>
                    <IconButton size="small" onClick={() => this.viewFormRejections(value, tableMeta)} style={btnStyle}>
                      <em className="icon ni ni-cross-circle" style={{ fontSize: 20, color: "#e85347" }}></em>
                    </IconButton>
                  </Tooltip>

                  {/* Delete Submission */}
                  <Tooltip title="Delete Submission" arrow>
                    <IconButton size="small" onClick={() => this.deleteGeneralModal(value)} style={btnStyle}>
                      <em className="icon ni ni-trash" style={{ fontSize: 20, color: "#e85347" }}></em>
                    </IconButton>
                  </Tooltip>
                </div>
              );
            },
          },
        },
        {
          name: "form_accountno",
          options: {
            display: false,
          },
        },
        {
          name: "form_token",
          options: {
            display: false,
          },
        },
        {
          name: "link_form",
          options: {
            display: false,
          },
        },
        {
          name: "external_link",
          options: {
            display: false,
          },
        },
        {
          name: "progress",
          label: "Report",
          options: {
            display: false,
          },
        },
        {
          name: "agent_id",
          label: "Active ID",
          options: {
            display: false,
          },
        },
        {
          name: "no_agent_contain",
          label: "Agent Availability",
          options: {
            display: false,
          },
        },
        {
          name: "is_active_agent",
          label: "Active Agent",
          options: {
            display: false,
          },
        },
      ],
    };
  }

  checkActiveAgent = async () => {
    try {
      const res = await axios.post(
        process.env.REACT_APP_API_URL + "forms/get_active_agent_popup",
        {
          token: process.env.REACT_APP_API_TOKEN,
          api_accountno: process.env.REACT_APP_API_ACCOUNTNO,
          accountno: auth.getAccount(),
        },
        {
          headers: {
            Authorization: `bearer ${auth.getToken()}`,
            "Content-Type": "application/json;charset=UTF-8",
          },
        },
      );

      if (res.data.status === 200 && res.data.active) {
        const { agent_id, popup_data } = res.data;
        return {
          active: true,
          agent_id,
          popup_data,
        };
      }

      return { active: false };
    } catch (error) {
      console.error("âŒ checkActiveAgent error:", error);
      return { active: false };
    }
  };

  async componentDidMount() {
    try {
      const form_accountno = this.props.props.match.params.form_accountno;
      const form_token = this.props.props.match.params.form_token;

      this.setState({
        formAccNo: form_accountno,
        form_token,
        form_accountno,
        assignedLoader: true,
      });

      // âœ… Check active popup from backend
      const activePopup = await this.checkActiveAgent();
      if (activePopup.active) {
        const { agent_id, popup_data } = activePopup;
        this.setState({
          activeAgentId: agent_id, // âœ… store globally active agent ID
          isLaunching: this.state.aiAgent?.agent_id === agent_id, // show Stop only for this agent
          currentAgentId: agent_id,
          currentAgentRoom: popup_data.livekit_room || null,
          currentAgentName: popup_data.agent_name || "AI Agent",
          currentUserForm: popup_data.user_form_enabled || "No",
          currentTelephonyToken: popup_data.telephony_token || null,
        });
      } else {
        this.setState({
          activeAgentId: null,
          isLaunching: false,
        });
      }

      // âœ… Load form + clients + sharelinks
      const servicesResponse = await getClientFormWithSubmissions(
        auth.getAccount(),
        auth.getToken(),
        form_accountno,
        form_token,
      );

      if (
        servicesResponse.data.status === 403 ||
        servicesResponse.data.errors === "authentication missing" ||
        servicesResponse.data.errors === "jwt expired"
      ) {
        auth.logout();
        return;
      }

      if (servicesResponse.data.status === 404) {
        this.setState({
          tableLoader: false,
          tableLoaderListing: false,
          assignedLoader: false,
          errorMessageTotalsTitle: "No Submission",
          errorMessageTotals: "There are no submissions right now.",
        });
      } else if (servicesResponse.data.status === 200) {
        const sharelinks = servicesResponse.data.agentSharelinks || [];
        const clients = servicesResponse.data.clientList || [];
        const formData = servicesResponse.data.data?.[0] || {};

        this.setState({
          form_title: servicesResponse.data.form_title,
          totalSubmissions: servicesResponse.data.total_submissions,
          form_desc: servicesResponse.data.form_desc,
          total_completed: servicesResponse.data.total_completed,
          total_not_completed: servicesResponse.data.total_not_completed,
          allow_multiple: formData.allow_multiple,
          form_link: formData.form_link || "",
          agentSharelinks: sharelinks.map((s) => ({
            label: s.title,
            value: s.id,
          })),
          clientList: clients.map((c) => ({
            label: `${c.name} (${c.comp_name})`,
            value: c.id,
          })),
          tableLoader: false,
          tableLoaderListing: false,
          assignedLoader: false,
        });
      }

      // âœ… Fetch Twilio Numbers
      this.fetchTwilioNumbers();
    } catch (err) {
      console.error("âŒ componentDidMount error:", err);
      this.setState({
        assignedLoader: false,
        tableLoader: false,
        tableLoaderListing: false,
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.aiAgent?.agent_id !== this.state.aiAgent?.agent_id ||
      prevState.agentPid !== this.state.agentPid
    ) {
      this.checkActiveAgent().then((res) => {
        if (res.active) {
          const isCurrentAgentActive =
            res.agent_id === this.state.aiAgent?.agent_id;

          this.setState({
            activeAgentId: res.agent_id,
            isLaunching: isCurrentAgentActive, // âœ… only true for this agent
          });
        } else {
          this.setState({
            activeAgentId: null,
            isLaunching: false,
          });
        }
      });
    }
  }

  toggleAgentPopup = async () => {
    const { aiAgent, agentPid } = this.state;
    const accountno = auth.getAccount();
    const action = this.state.isLaunching ? "deactivate" : "activate";

    this.setState({ isProcessingPopup: true, popupMessage: null });

    try {
      const res = await axios.post(
        process.env.REACT_APP_API_URL + "forms/toggle_agent_popup",
        {
          token: process.env.REACT_APP_API_TOKEN,
          api_accountno: process.env.REACT_APP_API_ACCOUNTNO,
          accountno,
          agentID: aiAgent?.agent_id,
          pid: agentPid,
          user_form_enabled: aiAgent?.user_form_enabled || "No",
          agent_name: aiAgent?.agent_name || "AI Agent",
          telephony_token: aiAgent?.telephony_token || null,
          livekit_room: aiAgent?.livekit_room || null,
          action,
        },
        {
          headers: {
            Authorization: `bearer ${auth.getToken()}`,
            "Content-Type": "application/json;charset=UTF-8",
          },
        },
      );

      const data = res.data;
      if (data.status === 200) {
        this.setState({
          isLaunching: action === "activate",
          activeAgentId: action === "activate" ? aiAgent?.agent_id : null, // âœ… Track active agent globally
          popupMessage: {
            type: "success",
            text:
              action === "activate"
                ? "AI Agent preview launched successfully!"
                : "Preview stopped successfully.",
          },
        });

        // âœ… Refresh the page after short delay
        setTimeout(() => {
          window.location.reload();
        }, 1200);
      } else {
        this.setState({
          popupMessage: {
            type: "error",
            text: data.message || "Failed to update preview state.",
          },
        });
      }
    } catch (err) {
      console.error("toggleAgentPopup error:", err);
      this.setState({
        popupMessage: {
          type: "error",
          text: "Unexpected error while updating agent preview.",
        },
      });
    } finally {
      this.setState({ isProcessingPopup: false });
    }
  };

  format_agent_link = (value, tableMeta) => {
    const agent_id = tableMeta.rowData[15]; // agent_id
    const no_agent_contain = tableMeta.rowData[16]; // true / false
    const is_active_agent = tableMeta.rowData[17]; // from backend new field

    // Prefer backend boolean, fallback to state match
    const isActiveAgent =
      is_active_agent === 1 || this.state.activeAgentId === agent_id;

    // If this form has no agent, show "---"
    if (no_agent_contain === true) {
      return <span>---</span>;
    }

    return (
      <span
        className="badge badge-outline-primary"
        style={{
          cursor: "pointer",
          display: "inline-flex",
          alignItems: "center",
          gap: "4px",
        }}
        onClick={(e) => {
          e.preventDefault();
          this.openAgentActions({
            form_token: tableMeta.rowData[11], // Adjust index if needed
            form_accountno: tableMeta.rowData[10],
          });
        }}
      >
        <em className="icon ni ni-setting"></em>
        Configure
        {/* Green dot if the agent is active */}
        {isActiveAgent && (
          <span
            style={{
              width: "8px",
              height: "8px",
              borderRadius: "50%",
              backgroundColor: "green",
              marginLeft: "6px",
            }}
          ></span>
        )}
      </span>
    );
  };

  format_submission_status = (value, tableMeta) => {
    const is_submitted = tableMeta.rowData[3];
    if (is_submitted === 1) {
      if (value === 0) {
        return (
          <span className="badge badge-outline-primary">
            <em className="icon ni ni-done"></em> Pending Approval
          </span>
        );
      } else if (value === 1) {
        return (
          <span className="badge badge-outline-success">
            <em className="icon ni ni-caution"></em> Approved
          </span>
        );
      } else if (value === 2) {
        return (
          <span className="badge badge-outline-danger">
            <em className="icon ni ni-caution"></em> Rejected
          </span>
        );
      } else {
        return (
          <span className="badge badge-outline-primary">
            <em className="icon ni ni-caution"></em> Pending Approval
          </span>
        );
      }
    } else {
      if (value === 2) {
        return (
          <span className="badge badge-outline-danger">
            <em className="icon ni ni-caution"></em> Rejected
          </span>
        );
      } else {
        return "---";
      }
    }
  };

  format_client_title = (value, tableMeta) => {

    let progressPercentage = 0;

    if (tableMeta.rowData[14]) {
      let progress = tableMeta.rowData[14];
      let [completed, total] = progress.split("/").map(Number);
      progressPercentage = (completed / total) * 100;
    }
    return (
      <div className="progress-list gy-3">
        <div className="progress-wrap">
          <div className="progress-text">
            <div className="progress-label text-dark fs-10">
              {this.state.form_title}
            </div>
            <div className="progress-amount text-dark">
              {progressPercentage.toFixed(2)}%
            </div>
          </div>
          <div className="progress progress-md">
            <div
              className="progress-bar bg-teal"
              data-progress={progressPercentage}
              style={{
                width: `${progressPercentage}%`,
              }}
            ></div>
          </div>
        </div>
      </div>
    );
    //return this.state.form_title;
  };

  format_submitted = (value) => {
    if (value === 1) {
      return (
        <span className="badge badge-outline-success">
          <em className="icon ni ni-done"></em> Yes
        </span>
      );
    } else {
      return (
        <span className="badge badge-outline-light">
          <em className="icon ni ni-caution"></em> No
        </span>
      );
    }
  };

  format_download_general = (value, tableMeta) => {
    let form_token = tableMeta.rowData[11];
    if (value && value !== "") {
      return (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "6px",
            flexWrap: "wrap", // allows responsive wrapping if absolutely needed
            justifyContent: "center",
            minWidth: "70px",
          }}
        >
          <a
            onClick={() => this.downloadPdf(value)}
            title="Download PDF"
            style={{ cursor: "pointer" }}
          >
            <span
              className="badge badge-outline-primary"
              style={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                width: "28px",
                height: "21px",
                padding: 0,
              }}
            >
              <em className="icon ni ni-download"></em>
            </span>
          </a>

          <a
            onClick={() =>
              this.addMenuHistory("/agent_single_submissions/" + form_token)
            }
            title="Submission View"
            style={{ cursor: "pointer" }}
          >
            <span
              className="badge badge-outline-primary"
              style={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                width: "28px",
                height: "21px",
                padding: 0,
              }}
            >
              <em className="icon ni ni-eye"></em>
            </span>
          </a>
        </div>
      );
    } else {
      return <span className="badge badge-outline-light">---</span>;
    }
  };

  changeActiveTab = (tab) => {
    this.setState({
      activeTab: tab,
      //assignedLoader: true,
    });
  };

  format_date = (value, tableMeta) => {
    let date = value;
    if (date && date !== "") {
      //return dateFormat(date, "mmmm dS, yyyy, h:MM:ss TT");
      return dateFormat(date, "mm-dd-yyyy");
    }
    return "---";
  };

  handleChange = async (event) => {
    const { target } = event;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const { name } = target;

    this.setState({
      [name]: value,
    });
  };

  closeModal = () => {
    this.setState({ modalContent: null, formAccNo: "" }, () => {
      window.$("#modalPreviewForm").modal("hide");
    });
  };

  handleSubmitForm = (formData) => {
    let response = JSON.stringify(formData);
    this.saveResponse(response, this.state.formAccNo);
  };

  viewGeneralSubmission = async (id) => {
    const { form_accountno } = this.state;
    this.setState({ viewLoader: true, extra_files: [] });
    const servicesResponse = await viewGeneralSubmission(
      auth.getAccount(),
      auth.getToken(),
      form_accountno,
      id,
    );
    window.$("#modalViewGeneralSubmission").modal("show");
    // console.log("getTotalSubmissions.data.data: ", servicesResponse.data);

    if (
      servicesResponse.data.status === 403 ||
      servicesResponse.data.errors === "authentication missing" ||
      servicesResponse.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      servicesResponse.data.status === 404 &&
      servicesResponse.data.message === "form_not_found"
    ) {
      this.setState({
        errorMessageTotalsTitle: "No Submission",
        errorMessageTotals: "There are no submissions right now.",
        viewLoader: false,
      });
    } else if (
      servicesResponse.data.status === 200 &&
      servicesResponse.data.message === "success"
    ) {
      let extra_files = [];
      if (servicesResponse.data.data && servicesResponse.data.data.length > 0) {
        if (servicesResponse.data.data[0].extra_files) {
          extra_files = JSON.parse(servicesResponse.data.data[0].extra_files);
        }
      }
      this.setState({
        viewGeneralSubmission: servicesResponse.data.data,
        extra_files: extra_files,
        viewLoader: false,
      });

      //
    }
  };

  viewFormRejections = async (id, tableMeta) => {
    const { form_accountno, form_title } = this.state;
    this.setState({
      rejectGeneralErrorMessage: "",
      rejectGeneralSuccessMessage: "",
      allGeneralRejectionsListing: [],
      rejectionLoader: true,
    });
    window.$("#modalRejectionGeneral").modal("show");
    const servicesResponse = await allClientRejections(
      auth.getAccount(),
      auth.getToken(),
      form_accountno,
      id,
    );

    // console.log("allGeneralRejections: ", servicesResponse.data);

    if (
      servicesResponse.data.status === 403 ||
      servicesResponse.data.errors === "authentication missing" ||
      servicesResponse.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      servicesResponse.data.status === 404 &&
      servicesResponse.data.message === "form_not_found"
    ) {
      this.setState({
        approveGeneralErrorMessage: "Submission not found.",
        approveGeneralSuccessMessage: "",
        rejectionLoader: false,
      });
    } else if (
      servicesResponse.data.status === 404 &&
      servicesResponse.data.message === "rejection_not_found"
    ) {
      this.setState({
        approveGeneralErrorMessage:
          "There are no rejections against this submission.",
        approveGeneralSuccessMessage: "",
        rejectionLoader: false,
      });
    } else if (
      servicesResponse.data.status === 200 &&
      servicesResponse.data.message === "success"
    ) {
      this.setState({
        approveGeneralErrorMessage: "",
        approveGeneralSuccessMessage: "",

        allGeneralRejectionsListing: servicesResponse.data.data,
        rejectionLoader: false,
      });
    } else {
      this.setState({
        rejectionLoader: false,
        approveGeneralErrorMessage:
          "There is some error while getting the rejections.",
        approveGeneralSuccessMessage: "",
      });
    }
  };

  deleteGeneralModal = async (id) => {
    this.setState({
      submission_id: id,
      errorMessageDelete: "",
      successMessageDelte: "",
    });
    window.$("#modalDeleteGeneralAlert").modal("show");
  };

  modalHideDelGeneral = async () => {
    this.setState({
      submission_id: "",
      errorMessageDelete: "",
      successMessageDelte: "",
    });
    window.$("#modalDeleteGeneralAlert").modal("hide");
  };

  deleteGeneralSubmission = async () => {
    const { form_accountno, submission_id } = this.state;

    // âœ… Start loading state
    this.setState({ isProcessing: true, viewLoader: true });

    try {
      const servicesResponse = await deleteSubmission(
        auth.getAccount(),
        auth.getToken(),
        form_accountno,
        submission_id,
      );

      const res = servicesResponse?.data;

      if (
        res.status === 403 ||
        res.errors === "authentication missing" ||
        res.errors === "jwt expired"
      ) {
        auth.logout();
        return;
      }

      if (res.status === 404 && res.message === "form_not_found") {
        this.setState({
          errorMessageDelete: "There are no submissions right now.",
          isProcessing: false,
          viewLoader: false,
        });
      } else if (res.status === 200 && res.message === "success") {
        this.setState({
          successMessageDelte: "Submission deleted successfully.",
          isProcessing: true, // remain disabled
          viewLoader: false,
        });

        // â± Reload after a short delay
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      } else {
        this.setState({
          errorMessageDelete: "Error failed to delete submission.",
          isProcessing: false,
          viewLoader: false,
        });
      }
    } catch (err) {
      console.error("Delete error:", err);
      this.setState({
        errorMessageDelete: "Unexpected error while deleting submission.",
        isProcessing: false,
        viewLoader: false,
      });
    }
  };

  addMenuHistory = (link) => {
    this.props.props.history.push(link);
  };

  downloadPdf = async (d_f_name) => {
    //var url = d_f_name;
    if (d_f_name && d_f_name !== "") {
      let file_name = d_f_name;
      var url = APP_LIVE_URL + "files_data/form_response_uploads/" + d_f_name;
      fetch(url)
        .then((x) => x.blob())
        .then((b) => {
          // console.log("B INSTANCE", b instanceof Blob);
          const url = window.URL.createObjectURL(b);
          var a = document.createElement("a");
          document.body.appendChild(a);
          a.style = "display: none";
          a.href = url;
          a.download = file_name;
          a.click();
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
          this.setState({
            errorMessage:
              "There is some error while downloading the attachment.",
          });
          setTimeout(() => {
            this.setState({ errorMessage: "" });
          }, 4000);
          // Handle any errors that occurred during the fetch
          console.error("Fetch error:", error);
        });
    } else {
      this.setState({
        errorMessage: "Attachement not found.",
      });
      setTimeout(() => {
        this.setState({ errorMessage: "" });
      }, 4000);
    }
  };

  validateEmailAdd = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isValidEmail = emailRegex.test(email);
    //console.log("isValidEmail: " + " " + email + " = " + isValidEmail);
    if (isValidEmail) {
      return true;
    }
    return false;
  };

  fieldValidation = () => {
    let { emailtoname, emailto, emailsubject, emailcontent } = this.state;

    if (emailtoname === "") {
      this.setState({
        emailErrorMessageTitle: "Missing Fields",
        emailErrorMessage: "Name is required.",
      });
      return false;
    } else if (emailto === "") {
      this.setState({
        emailErrorMessageTitle: "Missing Fields",
        emailErrorMessage: "To email address is required.",
      });
      return false;
    } else if (this.validateEmailAdd(emailto) === false) {
      this.setState({
        emailErrorMessageTitle: "Invalid Format",
        emailErrorMessage: "Invalid email address format.",
      });
      return false;
    } else if (emailsubject === "") {
      this.setState({
        emailErrorMessageTitle: "Missing Fields",
        emailErrorMessage: "Subject is required.",
      });
      return false;
    } else if (emailcontent === "") {
      this.setState({
        emailErrorMessageTitle: "Missing Fields",
        emailErrorMessage: "Custom content is required.",
      });
      return false;
    } else {
      this.setState({
        emailErrorMessageTitle: "",
        emailErrorMessage: "",
      });
    }
    return true;
  };

  submitFormEmail = async () => {
    const { form_accountno, emailtoname, emailto, emailsubject, emailcontent } =
      this.state;

    if (this.fieldValidation() === true) {
      this.setState({
        email_button: true,
        emailErrorMessage: "",
        emailErrorMessageTitle: "",
        emailSuccessMessage: "",
      });
      const servicesResponce = await sendFormEmail(
        auth.getAccount(),
        auth.getToken(),
        form_accountno,
        emailtoname,
        emailto,
        emailsubject,
        emailcontent,
      );
      // console.log("submitOrderEmail: ", servicesResponce.data);

      if (
        servicesResponce.data.status === 403 ||
        servicesResponce.data.errors === "authentication missing" ||
        servicesResponce.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (
        servicesResponce.data.status === 404 &&
        servicesResponce.data.message === "already_sent"
      ) {
        this.setState({
          emailErrorMessageTitle: "Already Sent",
          emailErrorMessage:
            "This form has already been sent to the email and is still not submitted.",
          email_button: false,
        });
      } else if (
        servicesResponce.data.status === 404 &&
        servicesResponce.data.message === "insert_error"
      ) {
        this.setState({
          emailErrorMessageTitle: "System Error",
          emailErrorMessage: "This is some error while sending the form.",
          email_button: false,
        });
      } else if (
        servicesResponce.data.status === 200 &&
        servicesResponce.data.message === "success"
      ) {
        this.setState({
          emailSuccessMessage: "Email sent successfully.",
          payment_status: servicesResponce.data.data,
          emailErrorMessageTitle: "",
          emailErrorMessage: "",
          emailsubject: "",
          emailto: "",
          emailtoname: "",
          emailcontent: "",
          email_button: false,
        });
      } else {
        this.setState({
          emailErrorMessageTitle: "System Error",
          emailErrorMessage:
            "There is some error while processing your request.",
          email_button: false,
        });
      }
    }

    setTimeout(() => {
      this.setState({
        emailErrorMessage: "",
        emailSuccessMessage: "",
      });
    }, 4000);
  };

  stopAIAgent = async () => {
    const { agentPid } = this.state;
    const agentId = this.state.aiAgent?.agent_id;

    // Validation
    if (!agentId || !agentPid) {
      this.setState({
        errorMessageAttach: "Missing agent ID or PID. Cannot stop agent.",
        isStoppingAgent: false,
      });
      return;
    }

    this.setState({
      isStoppingAgent: true,
      errorMessageAttach: null,
      successMessageAttach: null,
    });

    window.scrollTo({ top: 0, behavior: "smooth" });

    try {

      const submitFormResponse = await stopAIAgent(
        auth.getAccount(),
        auth.getToken(),
        agentId, // agent_id
        agentPid, // pid
      );

      const data = submitFormResponse.data;

      // Handle authentication errors
      if (
        data.status === 403 ||
        data.errors === "authentication missing" ||
        data.errors === "jwt expired"
      ) {
        auth.logout();
        return;
      }

      // Handle validation errors
      if (data.status === 404) {
        this.setState({
          isStoppingAgent: false,
          errorMessageAttach:
            data.message || "Agent session not found or already stopped.",
        });
        return;
      }

      // Handle success
      if (data.status === 200) {

        // Show success message
        this.setState({
          isStoppingAgent: false,
          isLaunching: false,
          agentPid: null,
          successMessageAttach:
            "AI Agent stopped successfully! All attachments cleared.",
          errorMessageAttach: null,
        });

        // Refresh the submissions list
        if (typeof this.getTotalSubmissions === "function") {
          this.getTotalSubmissions();
        }

        // Auto-close modal after 2 seconds
        setTimeout(() => {
          this.setState({
            successMessageAttach: null,
          });
          window.$("#modalAgentActions").modal("hide");
        }, 2000);

        return;
      }

      // Handle unexpected status
      this.setState({
        isStoppingAgent: false,
        errorMessageAttach:
          data.message || "Unexpected error while stopping the AI Agent.",
      });
    } catch (error) {
      console.error("âŒ Error stopping agent:", error);
      this.setState({
        isStoppingAgent: false,
        errorMessageAttach:
          "Network error while stopping the AI Agent. Please try again.",
      });
    }
  };

  attachAgentSharelinks = async () => {
    const modalBody = document.getElementById("modalAgentActions");
    if (modalBody) {
      setTimeout(() => {
        modalBody.scrollTo({ top: 0, behavior: "smooth" });
      }, 0);
    }
    const {
      agentID,
      selectedSharelinks,
      selectedClients,
      form_token_submission,
      agentRoom,
      aiAgent,
    } = this.state;

    this.setState({
      isProcessingAttach: true,
      successMessageAttach: "",
      errorMessageAttach: "",
    });

    try {
      // ðŸ§© Build sharelinkIds (can be empty)
      const sharelinkIds =
        selectedSharelinks && selectedSharelinks.length > 0
          ? selectedSharelinks.map((s) => s.value)
          : [];

      const clientIds = selectedClients?.length
        ? selectedClients.map((c) => c.value)
        : [];

      const userFormEnabled = aiAgent?.user_form_enabled || "No";
      const agentName = aiAgent?.agent_name || "AI Agent";

      // ðŸ”— API call
      const servicesResponse = await attachSharelinks(
        auth.getAccount(),
        auth.getToken(),
        agentID,
        sharelinkIds,
        clientIds,
        form_token_submission,
        agentRoom,
        userFormEnabled,
        agentName,
      );

      const data = servicesResponse.data;

      // ðŸ”’ Auth failures
      if (
        data.status === 403 ||
        data.errors === "authentication missing" ||
        data.errors === "jwt expired"
      ) {
        auth.logout();
        return;
      }

      // âœ… Success cases
      if (data.status === 200 && data.message === "success") {
        const msg =
          "Agent Link successfully updated to Sharelinks and Clients.";

        this.setState(
          {
            successMessageAttach: msg,
            isProcessingAttach: false,
          },
          () => {
            setTimeout(() => {
              window.$("#modalAgentActions").modal("hide");
              this.setState({
                successMessageAttach: "",
                selectedSharelinks: [],
              });
            }, 2000);
          },
        );
        return;
      }

      // ðŸš« Specific backend responses
      if (data.status === 404 && data.message === "agent_not_found") {
        this.setState({
          errorMessageAttach: "Agent not found. Please refresh and try again.",
          isProcessingAttach: false,
        });
        return;
      }

      if (data.status === 404 && data.message === "no_records_updated") {
        this.setState({
          errorMessageAttach:
            "No Sharelinks were updated. Please check your selection.",
          isProcessingAttach: false,
        });
        return;
      }

      if (data.status === 400 && data.message === "no_sharelinks") {
        this.setState({
          errorMessageAttach:
            "No Sharelinks were selected. Please choose one or click Attach to remove all.",
          isProcessingAttach: false,
        });
        return;
      }

      // ðŸ§© Catch-all fallback
      this.setState({
        errorMessageAttach:
          data.message ||
          "Failed to update Sharelinks. Please try again after a few moments.",
        isProcessingAttach: false,
      });
    } catch (error) {
      console.error("Error attaching Sharelinks:", error);
      this.setState({
        errorMessageAttach:
          error.response?.data?.message ||
          "Unexpected error occurred while updating Sharelinks. Please try again.",
        isProcessingAttach: false,
      });
    }
  };

  openAgentActions = async ({ form_token, form_accountno }) => {
    this.setState({
      selectedSharelinks: [],
      selectedClients: [],
      successMessageAttach: "",
      errorMessageAttach: "",
      attachedFetchError: "",
      isFetchingAttached: true,
      aiAgent: null,
      agentPid: null,
      agentRoom: null,
      agentID: null,
      form_token_submission: form_token,
    });

    try {
      const resp = await fetchAttachedSharelinks(
        auth.getAccount(),
        auth.getToken(),
        form_token,
        form_accountno,
      );

      const { data } = resp;

      if (
        data.status === 403 ||
        data.errors === "authentication missing" ||
        data.errors === "jwt expired"
      ) {
        auth.logout();
        return;
      }

      // âœ… Extract agent session info
      const aiAgent = Array.isArray(data.aiAgentSession)
        ? data.aiAgentSession[0]
        : null;

      // âœ… Preselect Twilio Number if attached
      if (data.attached_number && data.attached_number.twilio_sid) {
        this.setState({
          selectedTwilioSid: data.attached_number.twilio_sid,
          preAttachedTwilioNumber: data.attached_number.twilio_number || "",
        });
      } else {
        this.setState({
          selectedTwilioSid: "",
          preAttachedTwilioNumber: "",
        });
      }

      // âœ… Check if valid active agent exists
      const hasActiveAgent =
        aiAgent && aiAgent.agent_id && aiAgent.status !== "stopped";

      if (!hasActiveAgent) {
        // âŒ No active agent â†’ show a dedicated modal instead
        const msg =
          aiAgent && aiAgent.status === "stopped"
            ? "The AI Agent is currently stopped. Please restart or create a new one."
            : "No AI Agent found for this form. Please create one first.";

        this.setState({
          isFetchingAttached: false,
          inactiveAgentMessage: msg,
        });

        // Show the â€œinactive agentâ€ modal
        window.$("#modalNoAgent").modal("show");
        return; // stop here, donâ€™t open main modal
      }

      // âœ… Continue only if agent exists and is active
      window.$("#modalAgentActions").modal("show");

      const attachedSharelinks = Array.isArray(data.attached_sharelinks)
        ? data.attached_sharelinks
        : [];
      const attachedClients = Array.isArray(data.attached_clients)
        ? data.attached_clients
        : [];

      const sharelinkOptions = this.state.agentSharelinks;
      const clientOptions = this.state.clientList;

      const preSelectedSharelinks = attachedSharelinks.map((a) => {
        const match = sharelinkOptions.find((o) => o.value === a.id);
        return match || { label: a.title, value: a.id };
      });

      const preSelectedClients = attachedClients.map((a) => {
        const match = clientOptions.find((o) => o.value === a.id);
        const label = a.comp_name ? `${a.name} (${a.comp_name})` : a.name;
        return match || { label, value: a.id };
      });

      // âœ… Save both agent and PID in state
      this.setState({
        selectedSharelinks: preSelectedSharelinks,
        selectedClients: preSelectedClients,
        isFetchingAttached: false,
        errorMessageAttach: "",
        aiAgent: aiAgent,
        agentPid: aiAgent?.pid || null,
        agentID: aiAgent?.agent_id || null,
        agentRoom: aiAgent?.livekit_room || null,
      });
    } catch (e) {
      console.error("fetchAttachedSharelinks error:", e);
      this.setState({
        attachedFetchError: "Could not load attached data.",
        isFetchingAttached: false,
      });
    }
  };

  // toggleAgentPopup = () => {
  //   const { aiAgent, agentPid } = this.state;
  //   const accountno = auth.getAccount(); // âœ… Logged-in user account

  //   // === Retrieve existing popup from localStorage
  //   const saved = localStorage.getItem("activeAgentPopup");
  //   let currentActive = null;
  //   if (saved) {
  //     try {
  //       currentActive = JSON.parse(saved);
  //     } catch {
  //       currentActive = null;
  //     }
  //   }

  //   const isSameAgent =
  //     currentActive &&
  //     currentActive.agent_id === aiAgent?.agent_id &&
  //     currentActive.pid === agentPid &&
  //     currentActive.accountno === accountno;

  //   // === Case 1ï¸âƒ£: Stop current preview (same agent + same account)
  //   if (isSameAgent) {
  //     localStorage.removeItem("activeAgentPopup");
  //     localStorage.removeItem("telephony_token");
  //     this.setState({ isLaunching: false });
  //     window.$("#modalAgentActions").modal("hide");
  //     window.location.reload();
  //     return;
  //   }

  //   // === Case 2ï¸âƒ£: Launch new preview (new agent/account)
  //   const agentData = {
  //     show: true,
  //     agent_id: aiAgent?.agent_id || null,
  //     livekit_room: aiAgent?.livekit_room || null,
  //     pid: agentPid || null,
  //     accountno: accountno || null,
  //     user_form_enabled: aiAgent?.user_form_enabled || "No",
  //     agent_name: aiAgent?.agent_name || "AI Agent",
  //     telephony_token: aiAgent?.telephony_token || null, // âœ… store secure token
  //     timestamp: new Date().toISOString(),
  //   };

  //   // ðŸ§  Update localStorage
  //   localStorage.removeItem("activeAgentPopup");
  //   localStorage.setItem("activeAgentPopup", JSON.stringify(agentData));

  //   // ðŸ§© Store a few quick-access items for global access
  //   localStorage.setItem(
  //     "user_form_enabled",
  //     aiAgent?.user_form_enabled || "No"
  //   );
  //   localStorage.setItem("agent_name", aiAgent?.agent_name || "AI Agent");

  //   if (aiAgent?.telephony_token) {
  //     localStorage.setItem("telephony_token", aiAgent.telephony_token);
  //   } else {
  //     localStorage.removeItem("telephony_token");
  //   }

  //   this.setState({ isLaunching: true });

  //   // ðŸŽ¬ Close modal and reload cleanly
  //   window.$("#modalAgentActions").modal("hide");
  //   window.location.reload();
  // };

  fetchTwilioNumbers = async () => {
    const response = await getAgentTwilioVerificationData(
      auth.getAccount(),
      auth.getToken(),
    );

    if (
      response.data.status === 403 ||
      response.data.errors === "authentication missing" ||
      response.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      response.data.status === 200 &&
      response.data.message === "success"
    ) {
      const formattedData = response.data.data.map((item) => [
        item.created_at,
        item.phone_number,
        item.sid,
        item.region,
        item.sms_enabled,
        item.voice_enabled,
      ]);
      this.setState({ phoneId: formattedData });
    } else {
    }
  };

  handleMakeConnection = async () => {
    this.setState({
      isConnecting: true,
      connectionSuccess: false,
      connectionError: "",
    });

    try {
      const selected = this.state.phoneId.find(
        (item) => item[2] === this.state.selectedTwilioSid,
      );
      const phoneNumber = selected ? selected[1] : "";

      // âœ… Call backend API instead of direct telephony endpoint
      const response = await makeOutboundConnection(
        auth.getAccount(),
        auth.getToken(),
        this.state.aiAgent?.agent_id || "N/A",
        this.state.selectedTwilioSid,
        phoneNumber,
        "+12014557709",
        this.state.aiAgent?.livekit_room || "moinc_room",
      );

      const data = response.data;

      // ðŸ”’ Auth failures
      if (
        data.status === 403 ||
        data.errors === "authentication missing" ||
        data.errors === "jwt expired"
      ) {
        auth.logout();
        return;
      }

      // âœ… Success case
      if (data.status === 200 && data.message === "success") {
        this.setState({
          isConnecting: false,
          connectionSuccess: true,
        });

        // Clear success message after 3 seconds
        setTimeout(() => {
          this.setState({ connectionSuccess: false });
        }, 3000);
      } else {
        throw new Error(data.message || "Connection failed");
      }
    } catch (error) {
      console.error("Connection error:", error);

      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        "Failed to establish connection";

      this.setState({
        isConnecting: false,
        connectionError: errorMessage,
      });

      // Clear error message after 5 seconds
      setTimeout(() => {
        this.setState({ connectionError: "" });
      }, 5000);
    }
  };

  attachAgentNumber = async () => {
    const modalBody = document.getElementById("modalAgentActions");
    if (modalBody) {
      setTimeout(() => {
        modalBody.scrollTo({ top: 0, behavior: "smooth" });
      }, 0);
    }

    const { aiAgent, selectedTwilioSid, phoneId } = this.state;

    this.setState({
      isProcessingNumberAttach: true,
      successMessageAttach: "",
      errorMessageAttach: "",
    });

    try {
      const selected = phoneId.find((item) => item[2] === selectedTwilioSid);
      const number = selected ? selected[1] : "";

      // âœ… API Call
      const res = await attachAgentNumberAPI(
        auth.getAccount(),
        auth.getToken(),
        aiAgent?.agent_id,
        selectedTwilioSid,
        number,
      );

      const data = res.data;

      // âœ… Unified success check
      if (data.status === 200) {
        const attachedNumber = data.attached_number || number;
        const formToken = data.form_token || null;
        const telephonyToken = data.telephony_token || null;

        // âœ… Update LocalStorage (activeAgentPopup & telephony_token)
        if (telephonyToken) {
          try {
            const activePopup = localStorage.getItem("activeAgentPopup");
            if (activePopup) {
              const parsed = JSON.parse(activePopup);
              parsed.telephony_token = telephonyToken;
              localStorage.setItem("activeAgentPopup", JSON.stringify(parsed));
            }
            localStorage.setItem("telephony_token", telephonyToken);
            
          } catch (err) {
            console.error("âš ï¸ Failed to update activeAgentPopup:", err);
          }
        }

        // âœ… UI Feedback
        this.setState({
          successMessageAttach: `Number ${attachedNumber} successfully attached and form updated!`,
          isProcessingNumberAttach: false,
        });


        // âœ… Smoothly refresh without reload
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      } else {
        // âŒ Backend returned failure
        this.setState({
          errorMessageAttach: data.message || "Failed to attach number.",
          isProcessingNumberAttach: false,
        });
      }
    } catch (error) {
      console.error("Attach number error:", error);
      this.setState({
        errorMessageAttach:
          error.response?.data?.message ||
          "Unexpected error while attaching number.",
        isProcessingNumberAttach: false,
      });
    }
  };

  removeAgentNumber = async () => {
    window.$("#modalRemoveNumber").modal("hide");
    const { aiAgent } = this.state;
    if (!aiAgent?.agent_id) return;

    this.setState({
      isRemovingNumber: true,
      successMessageAttach: "",
      errorMessageAttach: "",
    });

    try {
      const res = await axios.post(
        process.env.REACT_APP_API_URL + "forms/remove_agent_number",
        JSON.stringify({
          token: process.env.REACT_APP_API_TOKEN,
          api_accountno: process.env.REACT_APP_API_ACCOUNTNO,
          accountno: auth.getAccount(),
          agentID: aiAgent.agent_id,
        }),
        {
          headers: {
            Authorization: `bearer ${auth.getToken()}`,
            "Content-Type": "application/json;charset=UTF-8",
          },
        },
      );

      const data = res.data;

      if (data.status === 200) {
        // âœ… Update localStorage â€” just empty the telephony token
        const activePopup = localStorage.getItem("activeAgentPopup");
        if (activePopup) {
          try {
            const parsed = JSON.parse(activePopup);
            parsed.telephony_token = ""; // â¬…ï¸ clear but keep key
            localStorage.setItem("activeAgentPopup", JSON.stringify(parsed));
          } catch (err) {
            console.warn("âš ï¸ Failed to update activeAgentPopup:", err);
          }
        }

        // also clear stored standalone token but keep the key
        localStorage.setItem("telephony_token", "");

        const modalBody = document.getElementById("modalAgentActions");
        if (modalBody) {
          setTimeout(() => {
            modalBody.scrollTo({ top: 0, behavior: "smooth" });
          }, 0);
        }

        this.setState({
          successMessageAttach: "Number successfully removed and form updated!",
          errorMessageAttach: "",
          isRemovingNumber: false,
        });

        // âœ… Smoothly refresh attached data (no reload)
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      } else {
        this.setState({
          errorMessageAttach: data.message || "Failed to remove number.",
          successMessageAttach: "",
          isRemovingNumber: false,
        });
      }
    } catch (error) {
      console.error("Remove number error:", error);
      this.setState({
        errorMessageAttach:
          error.response?.data?.message ||
          "Unexpected error while removing number.",
        isRemovingNumber: false,
      });
    }
  };

  openRemoveNumberModal = () => {
    this.setState({
      showRemoveModal: true,
      successMessageAttach: "",
      errorMessageAttach: "",
    });
    window.$("#modalRemoveNumber").modal("show");
  };

  closeRemoveNumberModal = () => {
    window.$("#modalRemoveNumber").modal("hide");
    this.setState({ showRemoveModal: false });
  };

  render() {
    const { isLaunching, isStoppingAgent } = this.state;
    const { step } = this.state;
    const { email, VerifyUsernameButton } = this.state;
    const values = {
      email,
      VerifyUsernameButton,
    };
    //$(".nk-block .MUIDataTable-paper-2").css("padding", "10px");

    const disableClients =
      this.state.selectedSharelinks && this.state.selectedSharelinks.length > 0;

    const disableSharelinks =
      this.state.selectedClients && this.state.selectedClients.length > 0;
    return (
      <div className="nk-content ">
        <div className="container-fluid">
          {this.props.is_msa_signed === "No" &&
          this.props.from !== "dashboard" ? (
            <MsaWarning />
          ) : null}
          <div className="nk-content-inner">
            <div className="nk-content-body">
              <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between g-3">
                  <div className="nk-block-head-content">
                    <h3 className="nk-block-title page-title">
                      <a
                        onClick={() =>
                          this.addMenuHistory(
                            "/" + auth.getResellerRegToken() + "/client/forms",
                          )
                        }
                        style={{ cursor: "pointer" }}
                      >
                        Forms
                      </a>{" "}
                      /{" "}
                      <strong className="text-primary small">
                        {this.state.form_title}
                      </strong>
                    </h3>
                    <div className="nk-block-des text-soft">
                      <ul className="list-inline">
                        <li>
                          Form ID:{" "}
                          <span className="text-base">
                            {this.state.form_accountno}
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="nk-block-head-content">
                    <a
                      onClick={() => this.addMenuHistory("/cp_forms")}
                      //href="#"
                      class="btn btn-outline-light bg-white d-none d-sm-inline-flex"
                    >
                      <em className="icon ni ni-arrow-left"></em>
                      <span>Back</span>
                    </a>
                    <a
                      onClick={() => this.addMenuHistory("/cp_forms")}
                      //href="#"
                      class="btn btn-icon btn-outline-light bg-white d-inline-flex d-sm-none"
                    >
                      <em className="icon ni ni-arrow-left"></em>
                    </a>
                  </div>
                </div>
              </div>
              <div className="nk-block">
                <div className="card card-bordered">
                  <div className="card-aside-wrap form-submissions-layout">
                    <div className="card-content form-submissions-content">
                      <ul className="nav nav-tabs nav-tabs-mb-icon nav-tabs-card">
                        <li className="nav-item">
                          <a
                            className={`nav-link ${
                              this.state.activeTab === "total_submissions"
                                ? "active"
                                : ""
                            }`}
                            onClick={(e) => {
                              this.changeActiveTab("total_submissions");
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            <em className="icon ni ni-file-text"></em>
                            <span>Form Submissions</span>
                          </a>
                        </li>

                        <li className="nav-item">
                          <a
                            className={`nav-link ${
                              this.state.activeTab === "email_form"
                                ? "active"
                                : ""
                            }`}
                            onClick={(e) => {
                              this.changeActiveTab("email_form");
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            <em className="icon ni ni-mail"></em>
                            <span>Email Form</span>
                          </a>
                        </li>
                        {/*<li className="nav-item nav-item-trigger d-xxl-none">
                                                        <a className="toggle btn btn-icon btn-trigger" dataTarget="userAside"><em className="icon ni ni-user-list-fill"></em></a>
                                                    </li>*/}
                      </ul>
                      <div className="tab-content">
                        <div
                          className={
                            this.state.activeTab === "email_form"
                              ? "tab-pane active"
                              : "tab-pane"
                          }
                          id="email_forms"
                        >
                          <div className="card-inner">
                            <div className="nk-block">
                              {(this.state.allow_multiple === 0 &&
                                this.state.total_completed === 0) ||
                              this.state.allow_multiple === 1 ? (
                                <div className="row g-gs">
                                  <div className="col-sm-12">
                                    <h5>Send Form</h5>
                                    {this.state.emailErrorMessage !== "" ? (
                                      <div className="alert alert-pro alert-danger">
                                        <div className="alert-text">
                                          <h6>
                                            {this.state.emailErrorMessageTitle}
                                          </h6>
                                          <p>{this.state.emailErrorMessage}</p>
                                        </div>
                                      </div>
                                    ) : null}
                                    {this.state.emailSuccessMessage !== "" ? (
                                      <div className="alert alert-pro alert-success">
                                        <div className="alert-text">
                                          <h6>Success</h6>
                                          <p>
                                            {this.state.emailSuccessMessage}
                                          </p>
                                        </div>
                                      </div>
                                    ) : null}
                                  </div>
                                  <div className="col-sm-6">
                                    <div className="form-group mt-2">
                                      <label className="form-label" htmlFor="emailto">
                                        To Name <sup>*</sup>
                                      </label>
                                      <div className="form-control-wrap">
                                        <input
                                          type="text"
                                          className="form-control form-control-lg"
                                          id="emailtoname"
                                          name="emailtoname"
                                          value={this.state.emailtoname}
                                          onChange={this.handleChange}
                                          placeholder="Enter the full name"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-sm-6">
                                    <div className="form-group mt-2">
                                      <label className="form-label" htmlFor="emailto">
                                        To <sup>*</sup>
                                      </label>
                                      <div className="form-control-wrap">
                                        <input
                                          type="text"
                                          className="form-control form-control-lg"
                                          id="emailto"
                                          name="emailto"
                                          value={this.state.emailto}
                                          onChange={this.handleChange}
                                          placeholder="Enter email address"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-sm-12 mt-2">
                                    <div className="form-group">
                                      <label
                                        className="form-label"
                                        htmlFor="emailsubject"
                                      >
                                        Subject <sup>*</sup>
                                      </label>
                                      <div className="form-control-wrap">
                                        <input
                                          type="text"
                                          className="form-control form-control-lg"
                                          id="emailsubject"
                                          name="emailsubject"
                                          value={this.state.emailsubject}
                                          onChange={this.handleChange}
                                          placeholder="Email Subject"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-sm-12 mt-2">
                                    <div className="form-group">
                                      <label
                                        className="form-label"
                                        htmlFor="emailcontent"
                                      >
                                        Custom Message <sup>*</sup>
                                      </label>
                                      <div className="form-control-wrap">
                                        <textarea
                                          className="form-control"
                                          id="emailcontent"
                                          name="emailcontent"
                                          value={this.state.emailcontent}
                                          onChange={this.handleChange}
                                        ></textarea>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-sm-12 mt-2 d-flex justify-content-end">
                                    <div className="nk-block-head-content">
                                      <ul className="nk-block-tools gx-3">
                                        {this.state.email_button === true ? (
                                          <button
                                            className="btn btn-primary"
                                            type="button"
                                            disabled
                                          >
                                            <span
                                              className="spinner-grow spinner-grow-sm"
                                              role="status"
                                              aria-hidden="true"
                                            ></span>
                                            <span> Processing... </span>
                                          </button>
                                        ) : (
                                          <li>
                                            <a
                                              onClick={() =>
                                                this.submitFormEmail()
                                              }
                                              style={{
                                                cursor: "pointer",
                                                color: "#fff",
                                              }}
                                              class="btn btn-primary"
                                            >
                                              <em className="icon ni ni-check-round-cut"></em>{" "}
                                              <span>Send Email</span>{" "}
                                            </a>
                                          </li>
                                        )}
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              ) : (
                                <div className="row g-gs">
                                  <div className="col-sm-12">
                                    <div className="alert alert-pro alert-primary">
                                      <div className="alert-text">
                                        <h6>Form Submission Limit</h6>
                                        <p>
                                          You cannot send this form because it
                                          has already been submitted. Multiple
                                          submissions are not allowed.{" "}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        {/* EMAIL FORM */}
                        <div
                          className={
                            this.state.activeTab === "total_submissions"
                              ? "tab-pane active"
                              : "tab-pane"
                          }
                          id="tabItemAgreements"
                        >
                          <div className="card-inner">
                            <div className="nk-block">
                              <div className="nk-block-head">
                                <div className="d-flex justify-content-between align-items-center mb-4">
                                  <h5 className="title mb-0">
                                    Forms Submissions
                                  </h5>

                                  {/* Fill New Form Button */}
                                  {this.state.form_link && (
                                    <a
                                      onClick={() => {
                                        // Reset session so a brand-new form opens
                                        sessionStorage.removeItem(
                                          "skipResetDefaults",
                                        );
                                        sessionStorage.removeItem(
                                          "formInitialized",
                                        );

                                        this.addMenuHistory(
                                          "/agent_form_submit/" +
                                            this.state.form_link,
                                        );
                                      }}
                                      className="btn btn-primary"
                                      style={{
                                        cursor: "pointer",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "6px",
                                        color: "white",
                                      }}
                                    >
                                      <em className="icon ni ni-edit"></em>
                                      <span>Fill New Form</span>
                                    </a>
                                  )}
                                </div>

                                {this.state.assignedLoader === true ? (
                                  FormLoader()
                                ) : (
                                  <>
                                    <div
                                      className="tab-pane active"
                                      id="tabItemSigned"
                                    >
                                      {this.state.errorMessageTotals !== "" ? (
                                        <div className="example-alert example-alert-revoke">
                                          <div className="alert alert-pro alert-danger">
                                            <div className="alert-text">
                                              <h4>
                                                {
                                                  this.state
                                                    .errorMessageTotalsTitle
                                                }
                                              </h4>
                                              <p>
                                                {this.state.errorMessageTotals}
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      ) : null}
                                      <div className="card card-bordered card-preview form-submissions-table-card">
                                        <DataTableExtended
                                          columns={
                                            this.state.generalColumnServices
                                          }
                                          tableData={
                                            this.state.totalSubmissions
                                          }
                                          title=""
                                        />
                                      </div>
                                    </div>
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* EMAIL FORM */}
                        {/* <div className="nk-divider divider md"></div> */}
                      </div>
                    </div>
                    <div
                      className="card-aside card-aside-right user-aside form-submissions-aside"
                      data-content="userAside"
                      data-toggle-screen="xxl"
                      data-toggle-overlay="true"
                      data-toggle-body="true"
                      style={{ minHeight: "0vh" }}
                    >
                      <div className="card-inner-group" data-simplebar>
                        <div className="card-inner">
                          <div className="user-card user-card-s2">
                            <div className="user-info">
                              {/*{this.state.form_status &&
                              this.state.form_status === 1 ? (
                                <div className="badge badge-outline-success badge-pill ucap">
                                  Active
                                </div>
                              ) : (
                                <div className="badge badge-outline-light badge-pill ucap">
                                  Inactive
                                </div>
                              )}*/}

                              <h5>{this.state.form_title}</h5>
                              <span className="sub-text"></span>
                            </div>
                          </div>
                        </div>

                        <div className="card-inner text-center">
                          <h6 className="overline-title-alt mb-2">Totals</h6>
                          <div className="row text-center">
                            <div className="col-6">
                              <div className="profile-stats">
                                <span className="amount">
                                  {this.state.total_completed}
                                </span>
                                <span className="sub-text">Submitted</span>
                              </div>
                            </div>
                            <div className="col-6">
                              <div className="profile-stats">
                                <span className="amount">
                                  {this.state.total_not_completed}
                                </span>
                                <span className="sub-text">Not Submitted</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/*<div className="card-inner">
                          <h6 className="overline-title-alt mb-2">Additional</h6>
                          <div className="row g-3">
                            <div className="col-6">
                              <span className="sub-text">User ID:</span>
                              <span>UD003054</span>
                            </div>
                            <div className="col-6">
                              <span className="sub-text">Last Login:</span>
                              <span>15 Feb, 2019 01:02 PM</span>
                            </div>
                            <div className="col-6">
                              <span className="sub-text">KYC Status:</span>
                              <span className="lead-text text-success">
                                Approved
                              </span>
                            </div>
                            <div className="col-6">
                              <span className="sub-text">Register At:</span>
                              <span>Nov 24, 2019</span>
                            </div>
                          </div>
                        </div>*/}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* View General Submissions */}
              <div
                className="modal fade zoom"
                tabIndex="-1"
                id="modalViewGeneralSubmission"
              >
                <div
                  className="modal-dialog modal-xl modal-dialog-top"
                  role="document"
                >
                  <div className="modal-content">
                    <div className="modal-header">
                      <div
                        className="modal-title"
                        style={{ textAlign: "center", fontSize: "20px" }}
                      >
                        <strong>
                          <em className="icon ni ni-list-round"></em> Submission
                          Details{" "}
                        </strong>
                      </div>
                      <a
                        href="#"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <em className="icon ni ni-cross"></em>
                      </a>
                    </div>

                    <div className="modal-body">
                      {/* NRC DIVS START */}

                      {this.state.viewLoader === true ? (
                        FormLoader()
                      ) : (
                        <>
                          <div>
                            <div className="card card-bordered">
                              <div className="card-inner-group">
                                {this.state.viewGeneralSubmission &&
                                this.state.viewGeneralSubmission.length > 0 ? (
                                  <div className="card-inner">
                                    <div className="sp-plan-head">
                                      <h6 className="title">
                                        Form Submission Details
                                      </h6>
                                    </div>
                                    <div className="sp-plan-desc sp-plan-desc-mb">
                                      <table className="table table-bordered table-striped">
                                        {this.state.viewGeneralSubmission.map(
                                          (general, index) => (
                                            <tbody
                                              key={index}
                                              className="text-dark"
                                            >
                                              <tr>
                                                <td>Sent To Name</td>
                                                <td>
                                                  {general.submitter_name}
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>Sent To Email</td>
                                                <td>
                                                  {general.submitter_email}
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>Sent By</td>
                                                <td>
                                                  {general.sent_by_email &&
                                                  general.sent_by_email !== ""
                                                    ? general.sent_by_email
                                                    : "---"}
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>Sent Date</td>
                                                <td>
                                                  {this.format_date(
                                                    general.sent_on,
                                                  )}
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>Submitted</td>
                                                <td>
                                                  {general.is_submitted &&
                                                  general.is_submitted === 1 ? (
                                                    <span className="badge badge-dot badge-success">
                                                      Yes
                                                    </span>
                                                  ) : (
                                                    <span className="badge badge-dot badge-danger">
                                                      No
                                                    </span>
                                                  )}
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>Submission Date</td>
                                                <td>
                                                  {general.is_submitted &&
                                                  general.is_submitted === 1
                                                    ? this.format_date(
                                                        general.submitted_on,
                                                      )
                                                    : "---"}
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>View PDF</td>
                                                <td>
                                                  {general.is_submitted &&
                                                  general.is_submitted === 1 ? (
                                                    <a
                                                      style={{
                                                        cursor: "pointer",
                                                      }}
                                                      onClick={() =>
                                                        this.downloadPdf(
                                                          general.pdf_name,
                                                        )
                                                      }
                                                    >
                                                      <span className="badge badge-outline-dark">
                                                        View
                                                      </span>
                                                    </a>
                                                  ) : (
                                                    "---"
                                                  )}
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>Extra Files</td>
                                                <td>
                                                  {this.state.extra_files &&
                                                  this.state.extra_files
                                                    .length > 0 ? (
                                                    <>
                                                      {this.state.extra_files.map(
                                                        (file, index) => (
                                                          <>
                                                            {file.file_name &&
                                                            file.file_name !==
                                                              "" ? (
                                                              <div
                                                                key={index}
                                                                className="col-md-12"
                                                                style={{
                                                                  paddingLeft:
                                                                    "0px",
                                                                }}
                                                              >
                                                                {file.field_name.trim()}{" "}
                                                                <span
                                                                  onClick={() =>
                                                                    this.downloadPdf(
                                                                      file.file_name,
                                                                    )
                                                                  }
                                                                  class="badge badge-outline-primary"
                                                                  style={{
                                                                    cursor:
                                                                      "pointer",
                                                                  }}
                                                                  title="Download / View"
                                                                >
                                                                  <em className="icon ni ni-download"></em>{" "}
                                                                  {file.file_name.trim()}
                                                                </span>
                                                              </div>
                                                            ) : null}
                                                          </>
                                                        ),
                                                      )}
                                                    </>
                                                  ) : (
                                                    "---"
                                                  )}
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>Sent Form Subject</td>
                                                <td>
                                                  {general.email_subject &&
                                                  general.email_subject !== ""
                                                    ? general.email_subject
                                                    : "---"}
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>Sent Form Message</td>
                                                <td>
                                                  {general.email_content &&
                                                  general.email_content !== ""
                                                    ? general.email_content
                                                    : "---"}
                                                </td>
                                              </tr>
                                            </tbody>
                                          ),
                                        )}
                                      </table>
                                    </div>
                                  </div>
                                ) : null}
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {/* View General Submissions */}
              {/* START DELETE MODAL  */}
              <div
                className="modal fade"
                tabIndex="-1"
                id="modalDeleteGeneralAlert"
              >
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <a
                      style={{ cursor: "pointer" }}
                      className="close"
                      onClick={() => {
                        this.modalHideDelGeneral();
                      }}
                    >
                      <em className="icon ni ni-cross"></em>
                    </a>
                    <div className="modal-body modal-body-lg text-center">
                      <div className="nk-modal">
                        <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-trash bg-success"></em>

                        <h4 className="nk-modal-title">Delete Submission?</h4>

                        <div className="nk-modal-text">
                          {this.state.errorMessageDelete !== "" ? (
                            <div
                              className="example-alert"
                              style={{ marginBottom: "15px" }}
                            >
                              <div className="alert alert-pro alert-danger">
                                <div className="alert-text">
                                  <h4>Error</h4>
                                  <p>{this.state.errorMessageDelete}</p>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          {this.state.successMessageDelte !== "" ? (
                            <div
                              className="example-alert"
                              style={{ marginBottom: "15px" }}
                            >
                              <div className="alert alert-pro alert-success">
                                <div className="alert-text">
                                  <h4>Success</h4>
                                  <p>{this.state.successMessageDelte}</p>
                                </div>
                              </div>
                            </div>
                          ) : null}

                          <div className="caption-text">
                            Are you sure you want to delete this submission
                          </div>
                        </div>
                        <div className="nk-modal-action">
                          <button
                            style={{ cursor: "pointer", color: "white" }}
                            className="btn btn-lg btn-mw btn-primary"
                            onClick={() => {
                              this.modalHideDelGeneral();
                            }}
                          >
                            CANCEL
                          </button>
                          {"  "}
                          <button
                            style={{ cursor: "pointer", color: "white" }}
                            className="btn btn-lg btn-mw btn-danger"
                            onClick={() => {
                              this.deleteGeneralSubmission();
                            }}
                            disabled={this.state.isProcessing} // stays disabled during delete
                          >
                            {this.state.isProcessing ? (
                              <span>DELETING...</span>
                            ) : (
                              <span>DELETE</span>
                            )}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* END DELETE MODAL  */}
              {/* START REJECTIONS MODAL */}
              <div className="modal fade" tabIndex="-1" id="modalRejectionGeneral">
                <div
                  className="modal-dialog modal-dialog-top modal-xl"
                  role="document"
                >
                  <div className="modal-content">
                    <a
                      href="#"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <em className="icon ni ni-cross"></em>
                    </a>
                    <div className="modal-header">
                      <h5 className="modal-title">
                        All rejections{" "} <small className='text-muted'>- {this.state.form_title}</small>
                      </h5>
                    </div>
                    <div className="modal-body">
                      {this.state.rejectGeneralErrorMessage !== "" ? (
                        <div className="alert alert-pro alert-danger mb-2">
                          <div className="alert-text">
                            <h6>Error</h6>
                            <p>{this.state.rejectGeneralErrorMessage} </p>
                          </div>
                        </div>
                      ) : null}
                      {this.state.rejectGeneralSuccessMessage !== "" ? (
                        <div className="alert alert-pro alert-success mb-2">
                          <div className="alert-text">
                            <h6>Success</h6>
                            <p>{this.state.rejectGeneralSuccessMessage} </p>
                          </div>
                        </div>
                      ) : null}
                      <div id="revokeReasonItems">
                        {this.state.rejectionLoader === true ? (
                          FormLoader()
                        ) : (
                          <>
                            <div>
                              <div className="card card-bordered">
                                <div className="card-inner-group">
                                  {this.state.allGeneralRejectionsListing &&
                                  this.state.allGeneralRejectionsListing
                                    .length > 0 ? (
                                    <div className="card-inner">
                                      <div className="sp-plan-head">
                                        <h6 className="title">
                                          All Rejections{" "} <small className='text-muted'>- {this.state.form_title}</small>
                                        </h6>
                                      </div>
                                      <div className="sp-plan-desc sp-plan-desc-mb">
                                        <table className="table table-bordered table-striped">
                                          <thead>
                                            <th>Form Title</th>
                                            <th>Rejection date</th>
                                            <th>Reason</th>
                                            <th>Submitted PDF</th>
                                          </thead>
                                          {this.state.allGeneralRejectionsListing.map(
                                            (general, index) => (
                                              <tbody
                                                key={`ind${index}`}
                                                className="text-dark"
                                              >
                                                <tr>
                                                  <td>
                                                    {this.state.form_title}
                                                  </td>
                                                  <td>
                                                    {this.format_date(
                                                      general.rejection_date,
                                                    )}
                                                  </td>
                                                  <td>
                                                    {general.rejection_reason}
                                                  </td>
                                                  <td>
                                                    {general.is_submitted &&
                                                    general.is_submitted ===
                                                      1 ? (
                                                      <a
                                                        style={{
                                                          cursor: "pointer",
                                                        }}
                                                        onClick={() =>
                                                          this.downloadPdf(
                                                            general.pdf_name,
                                                          )
                                                        }
                                                      >
                                                        <span className="badge badge-outline-dark">
                                                          View
                                                        </span>
                                                      </a>
                                                    ) : (
                                                      "---"
                                                    )}
                                                  </td>
                                                </tr>
                                              </tbody>
                                            ),
                                          )}
                                        </table>
                                      </div>
                                    </div>
                                  ) : (
                                    <div className="alert alert-pro alert-primary">
                                      <div className="alert-text">
                                        <h6>No Rejection</h6>
                                        <p>
                                          Rejections are not available against
                                          this submission.
                                        </p>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* END REJECTIONS MODAL */}
              {/* === ACTION SELECTION MODAL === */}
              <div
                className="modal fade"
                id="modalAgentActions"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="modalAgentActionsLabel"
                aria-hidden="true"
              >
                <div
                  className="modal-dialog modal-dialog-top modal-xl"
                  role="document"
                >
                  <div className="modal-content">
                    {/* === Close Button === */}
                    <a
                      href="#"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <em className="icon ni ni-cross"></em>
                    </a>

                    {/* === Header === */}
                    <div className="modal-header">
                      <h5 className="modal-title" id="modalAgentActionsLabel">
                        <em
                          className="icon ni ni-setting"
                          style={{ marginRight: "5px" }}
                        ></em>
                        Agent Configuration
                      </h5>
                      <div
                        className="d-flex align-items-center"
                        style={{ gap: "10px" }}
                      >
                        {/* Copy Widget Link Button */}
                        {/* === Copy Widget Link Button === */}
                        {/* <a
                          type="button"
                          className="btn btn-sm btn-primary d-flex align-items-center"
                          style={{
                            height: "32px",
                            fontWeight: 500,
                            gap: "6px",
                            color: "white",
                            marginRight: "35px",
                          }}
                          onClick={() => {
                            const selected = this.state.phoneId.find(
                              (item) => item[2] === this.state.selectedTwilioSid
                            );
                            const sipNumber = selected ? selected[1] : "";
                            const sipTrunkId = "ST_uARcwdSB9sEP";
                            const phoneNumber = sipNumber;

                            // âœ… Build updated widget URL
                            const widgetUrl = new URL(
                              "https://development-chat.voiceadmins.com/embed"
                            );

                            widgetUrl.searchParams.append(
                              "agentName",
                              this.state.aiAgent?.agent_name || "AI Agent"
                            );
                            widgetUrl.searchParams.append(
                              "agentId",
                              this.state.aiAgent?.agent_id || ""
                            );
                            widgetUrl.searchParams.append(
                              "agentRoom",
                              this.state.aiAgent?.livekit_room || ""
                            );
                            widgetUrl.searchParams.append(
                              "form_enabled",
                              this.state.aiAgent?.user_form_enabled || "No"
                            );
                            widgetUrl.searchParams.append("theme", "#d4af37");

                            // âœ… Add telephony parameters
                            widgetUrl.searchParams.append(
                              "phoneSid",
                              this.state.selectedTwilioSid || ""
                            );
                            widgetUrl.searchParams.append(
                              "sipTrunkId",
                              sipTrunkId
                            );
                            widgetUrl.searchParams.append(
                              "phoneNumber",
                              phoneNumber || ""
                            );

                            // âœ… Copy to clipboard
                            navigator.clipboard
                              .writeText(widgetUrl.toString())
                              .then(() => {
                                this.setState({ widgetLinkCopied: true });
                                setTimeout(
                                  () =>
                                    this.setState({ widgetLinkCopied: false }),
                                  2000
                                );
                              });
                          }}
                          title="Copy widget link to clipboard"
                        >
                          <em
                            className={`icon ni ${
                              this.state.widgetLinkCopied
                                ? "ni-check"
                                : "ni-copy"
                            }`}
                            style={{
                              fontSize: "14px",
                              transition: "all 0.25s ease",
                              color: this.state.widgetLinkCopied
                                ? "#10b981"
                                : "white",
                              transform: this.state.widgetLinkCopied
                                ? "scale(1.25)"
                                : "scale(1)",
                              filter: this.state.widgetLinkCopied
                                ? "drop-shadow(0 0 6px rgba(16,185,129,0.5))"
                                : "none",
                            }}
                          ></em>
                          <span>
                            {this.state.widgetLinkCopied
                              ? "Copied!"
                              : "Copy Link"}
                          </span>
                        </a> */}
                      </div>
                    </div>

                    {/* === Body === */}
                    <div className="modal-body">
                      <div className="row g-4">
                        {/* === Error/Success Alerts === */}
                        {this.state.errorMessageAttach && (
                          <div className="col-md-12 mb-3">
                            <div className="alert alert-pro alert-danger mb-2">
                              <div className="alert-text">
                                <h4>Error</h4>
                                <p>{this.state.errorMessageAttach}</p>
                              </div>
                            </div>
                          </div>
                        )}
                        {this.state.successMessageAttach && (
                          <div className="col-md-12 mb-3">
                            <div className="alert alert-pro alert-success mb-2">
                              <div className="alert-text">
                                <h4>Success</h4>
                                <p>{this.state.successMessageAttach}</p>
                              </div>
                            </div>
                          </div>
                        )}
                        {this.state.popupMessage && (
                          <div className="col-md-12 mb-3">
                            <div
                              className={`alert alert-pro ${
                                this.state.popupMessage.type === "success"
                                  ? "alert-success"
                                  : "alert-danger"
                              } mb-2`}
                            >
                              <div className="alert-text">
                                <h4>
                                  {this.state.popupMessage.type === "success"
                                    ? "Success"
                                    : "Error"}
                                </h4>
                                <p>{this.state.popupMessage.text}</p>
                              </div>
                            </div>
                          </div>
                        )}

                        {/* === Launch Agent Preview === */}
                        <div className="col-lg-12">
                          <div
                            className="card p-4"
                            style={{
                              border: "1px solid #e5e7eb",
                              borderRadius: "8px",
                              backgroundColor: "#fff",
                            }}
                          >
                            <div className="d-flex justify-content-between align-items-start">
                              <div>
                                <h6 className="fw-bold mb-1">
                                  Launch Agent Preview
                                </h6>
                                <p className="text-muted mb-0">
                                  Open this AI Agent for a live interactive
                                  preview.
                                </p>
                              </div>

                              <div className="d-flex align-items-center">
                                {/* Launch / Stop Preview */}
                                <button
                                  type="button"
                                  onClick={this.toggleAgentPopup}
                                  disabled={this.state.isProcessingPopup}
                                  className={`btn d-flex align-items-center ${
                                    this.state.isLaunching
                                      ? "btn-danger"
                                      : "btn-primary"
                                  }`}
                                  style={{
                                    height: "38px",
                                    fontWeight: 500,
                                    marginRight: "8px",
                                    minWidth: "150px",
                                  }}
                                >
                                  {this.state.isProcessingPopup ? (
                                    <>
                                      <em className="icon ni ni-loader mr-1 animate-spin"></em>
                                      Processingâ€¦
                                    </>
                                  ) : (
                                    <>
                                      <span>
                                        {this.state.isLaunching
                                          ? "Stop Preview"
                                          : "Launch Preview"}
                                      </span>
                                      <em
                                        className={`icon ni ${
                                          this.state.isLaunching
                                            ? "ni-power"
                                            : "ni-forward-arrow"
                                        } ml-1`}
                                        style={{ fontSize: "15px" }}
                                      ></em>
                                    </>
                                  )}
                                </button>

                                {/* Stop Agent (only visible for active agent) */}
                                {/* {this.state.isLaunching && (
                                  <button
                                    className="btn btn-outline-danger d-flex align-items-center"
                                    onClick={this.stopAIAgent}
                                    disabled={this.state.isStoppingAgent}
                                    style={{ height: "38px", fontWeight: 500 }}
                                  >
                                    {this.state.isStoppingAgent ? (
                                      <>
                                        <em className="icon ni ni-loader mr-1 animate-spin"></em>
                                        Stoppingâ€¦
                                      </>
                                    ) : (
                                      <>
                                        <em className="icon ni ni-power mr-1"></em>{" "}
                                        Stop Agent
                                      </>
                                    )}
                                  </button>
                                )} */}
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* === Agent Twilio Numbers === */}
                        <div className="col-lg-12">
                          <div
                            className="card p-4"
                            style={{
                              border: "1px solid #e5e7eb",
                              borderRadius: "8px",
                              backgroundColor: "#fff",
                            }}
                          >
                            {/* Header */}
                            {/* === Agent Twilio Numbers Header === */}
                            <div
                              className="d-flex justify-content-between align-items-start mb-3 p-3"
                              style={{
                                backgroundColor: "#f9fafb",
                                border: "1px solid #e5e7eb",
                                borderRadius: "8px",
                              }}
                            >
                              <div>
                                <h6
                                  className="fw-bold mb-1"
                                  style={{ fontSize: "15px", color: "#111827" }}
                                >
                                  {/* <em
                                    className="icon ni ni-monitor"
                                    style={{
                                      fontSize: "16px",
                                      color: "#6576ff",
                                      marginRight: "5px",
                                    }}
                                  ></em> */}
                                  Agent Twilio Numbers
                                </h6>
                                <p
                                  className="text-muted mb-0"
                                  style={{ fontSize: "13px" }}
                                >
                                  Manage or connect Twilio numbers linked to
                                  this AI Agent.
                                </p>
                              </div>
                              {/* Agent ID and PID - Vertical Layout */}
                              <div
                                className="d-flex flex-column align-items-end"
                                style={{ gap: "8px" }}
                              >
                                {/* Agent ID */}
                                <div
                                  className="d-flex align-items-center"
                                  style={{
                                    fontSize: "13px",
                                    color: "#555",
                                    background: "#eef2ff",
                                    borderRadius: "6px",
                                    padding: "6px 12px",
                                    border: "1px solid #c7d2fe",
                                  }}
                                >
                                  <em
                                    className="icon ni ni-hash"
                                    style={{
                                      fontSize: "14px",
                                      marginRight: "5px",
                                      color: "#6576ff",
                                    }}
                                  ></em>
                                  <span>
                                    Agent ID:{" "}
                                    <strong>
                                      {this.state.aiAgent?.agent_id || "N/A"}
                                    </strong>
                                  </span>
                                </div>
                                {/* PID */}
                                {this.state.agentPid && (
                                  <div
                                    className="d-flex align-items-center"
                                    style={{
                                      fontSize: "13px",
                                      color: "#555",
                                      background: "#f0fdf4",
                                      borderRadius: "6px",
                                      padding: "6px 12px",
                                      border: "1px solid #bbf7d0",
                                    }}
                                  >
                                    <span>
                                      PID:{" "}
                                      <strong>{this.state.agentPid}</strong>
                                    </span>
                                  </div>
                                )}
                              </div>
                            </div>

                            {/* Twilio Select */}
                            <div>
                              <label
                                className="form-label fw-medium text-dark"
                                style={{ fontSize: "14px" }}
                              >
                                Select a Twilio Number
                              </label>

                              {/* â„¹ï¸ Why Attach a Number */}
                              <div
                                className="alert alert-pro alert-info mb-3"
                                style={{
                                  backgroundColor: "#eef2ff",
                                  border: "1px solid #c7d2fe",
                                  borderRadius: "8px",
                                  color: "#1e3a8a",
                                  fontSize: "13px",
                                  lineHeight: "1.6",
                                }}
                              >
                                <div className="d-flex align-items-start">
                                  <em
                                    className="icon ni ni-info-fill mr-2"
                                    style={{
                                      color: "#6576ff",
                                      fontSize: "16px",
                                      marginTop: "2px",
                                    }}
                                  ></em>
                                  <div>
                                    <strong>Why attach a Twilio number?</strong>
                                    <p className="mb-0 mt-1">
                                      Attaching a Twilio number allows your AI
                                      Agent to{" "}
                                      <strong>make outbound calls</strong>{" "}
                                      directly from the widget and handle{" "}
                                      <strong>live voice interactions</strong>.
                                      Without it, the â€œDialâ€ option inside the
                                      AI Agent widget remains disabled.
                                    </p>
                                  </div>
                                </div>
                              </div>

                              {this.state.phoneId &&
                              this.state.phoneId.length > 0 ? (
                                <select
                                  className="form-control"
                                  value={this.state.selectedTwilioSid || ""}
                                  onChange={(e) =>
                                    this.setState({
                                      selectedTwilioSid: e.target.value,
                                    })
                                  }
                                  style={{
                                    padding: "10px 14px",
                                    borderRadius: "6px",
                                    border: "1px solid #c7d2fe",
                                    outline: "none",
                                    backgroundColor: "#fff",
                                    fontSize: "14px",
                                    color: "#111827",
                                    cursor: "pointer",
                                    height: "45px",
                                    transition: "border-color 0.2s ease",
                                  }}
                                  onFocus={(e) =>
                                    (e.target.style.borderColor = "#798bff")
                                  }
                                  onBlur={(e) =>
                                    (e.target.style.borderColor = "#c7d2fe")
                                  }
                                >
                                  <option value="">Select a Twilio SID</option>
                                  {this.state.phoneId.map((item, idx) => {
                                    const sid = item[2];
                                    const num = item[1];
                                    return (
                                      <option key={idx} value={sid}>
                                        {num} &nbsp;&nbsp; ({sid})
                                      </option>
                                    );
                                  })}
                                </select>
                              ) : (
                                <p className="text-muted mb-0">
                                  No Twilio numbers found.{" "}
                                  <a
                                    href="/phone_number"
                                    style={{
                                      color: "#6576ff",
                                      fontWeight: "500",
                                      textDecoration: "none",
                                      marginLeft: "4px",
                                    }}
                                  >
                                    Click here
                                  </a>{" "}
                                  to add one.
                                </p>
                              )}
                            </div>

                            {/* Instruction Section */}
                            {this.state.selectedTwilioSid && (
                              <div
                                className="mt-3 p-3"
                                style={{
                                  backgroundColor: "#f9fafb",
                                  border: "1px dashed #cbd5e1",
                                  borderRadius: "6px",
                                }}
                              >
                                <h6
                                  className="fw-semibold mb-2"
                                  style={{ fontSize: "14px" }}
                                >
                                  Connection Instructions
                                </h6>
                                <p
                                  className="mb-1 text-muted"
                                  style={{
                                    fontSize: "13px",
                                    lineHeight: "1.6",
                                  }}
                                >
                                  To connect your Twilio number with this AI
                                  Agent, send the following JSON payload to your
                                  API endpoint:
                                </p>
                                <div style={{ position: "relative" }}>
                                  <pre
                                    style={{
                                      background: "#f3f4f6",
                                      padding: "10px",
                                      borderRadius: "6px",
                                      fontSize: "13px",
                                      whiteSpace: "pre-wrap",
                                      paddingRight: "40px",
                                    }}
                                  >
                                    {(() => {
                                      const selected = this.state.phoneId.find(
                                        (item) =>
                                          item[2] ===
                                          this.state.selectedTwilioSid,
                                      );
                                      const sipNumber = selected
                                        ? selected[1]
                                        : "";

                                      const payload = {
                                        agent_id:
                                          this.state.aiAgent?.agent_id || "N/A",
                                        number_id: this.state.selectedTwilioSid,
                                        sip_number: sipNumber,
                                        sip_trunk_id: "ST_uARcwdSB9sEP",
                                        sip_call_to: "+12014557709",
                                        room_name:
                                          this.state.aiAgent?.livekit_room ||
                                          "Agent Room",
                                        participant_identity:
                                          this.state.aiAgent?.agent_name ||
                                          "Maya",
                                        participant_name:
                                          this.state.aiAgent?.agent_name ||
                                          "Maya",
                                        wait_until_answered: true,
                                        krisp_enabled: true,
                                      };

                                      return JSON.stringify(payload, null, 2);
                                    })()}
                                  </pre>

                                  {/* Copy Button */}
                                  <button
                                    type="button"
                                    onClick={() => {
                                      const selected = this.state.phoneId.find(
                                        (item) =>
                                          item[2] ===
                                          this.state.selectedTwilioSid,
                                      );
                                      const sipNumber = selected
                                        ? selected[1]
                                        : "";

                                      const jsonPayload = {
                                        agent_id:
                                          this.state.aiAgent?.agent_id || "N/A",
                                        number_id: this.state.selectedTwilioSid,
                                        sip_number: sipNumber,
                                        sip_trunk_id: "ST_uARcwdSB9sEP",
                                        sip_call_to: "+12014557709",
                                        room_name:
                                          this.state.aiAgent?.livekit_room ||
                                          "Agent Room",
                                        participant_identity:
                                          this.state.aiAgent?.agent_name ||
                                          "Maya",
                                        participant_name:
                                          this.state.aiAgent?.agent_name ||
                                          "Maya",
                                        wait_until_answered: true,
                                        krisp_enabled: true,
                                      };

                                      navigator.clipboard
                                        .writeText(
                                          JSON.stringify(jsonPayload, null, 2),
                                        )
                                        .then(() => {
                                          this.setState({
                                            twilioJsonCopied: true,
                                          });
                                          setTimeout(() => {
                                            this.setState({
                                              twilioJsonCopied: false,
                                            });
                                          }, 2000);
                                        });
                                    }}
                                    style={{
                                      position: "absolute",
                                      top: "8px",
                                      right: "8px",
                                      background: "transparent",
                                      border: "none",
                                      outline: "none",
                                      borderRadius: "6px",
                                      padding: "6px 8px",
                                      cursor: "pointer",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      transition: "all 0.25s ease",
                                    }}
                                    title="Copy JSON"
                                  >
                                    <em
                                      className={`icon ni ${
                                        this.state.twilioJsonCopied
                                          ? "ni-check"
                                          : "ni-copy"
                                      }`}
                                      style={{
                                        fontSize: "18px",
                                        color: this.state.twilioJsonCopied
                                          ? "#10b981"
                                          : "#6b7280",
                                        transform: this.state.twilioJsonCopied
                                          ? "scale(1.2)"
                                          : "scale(1)",
                                        transition: "all 0.25s ease",
                                        filter: this.state.twilioJsonCopied
                                          ? "drop-shadow(0 0 4px rgba(16,185,129,0.6))"
                                          : "none",
                                      }}
                                    ></em>
                                  </button>
                                </div>

                                {/* âœ… Show "Attached" if selectedTwilioSid matches pre-attached number */}
                                {this.state.preAttachedTwilioNumber &&
                                this.state.phoneId.some(
                                  (item) =>
                                    item[2] === this.state.selectedTwilioSid &&
                                    item[1] ===
                                      this.state.preAttachedTwilioNumber,
                                ) ? (
                                  <div
                                    className="mt-3 d-flex align-items-center justify-content-between"
                                    style={{
                                      backgroundColor: "#f0fdf4",
                                      border: "1px solid #bbf7d0",
                                      borderRadius: "8px",
                                      padding: "10px 14px",
                                    }}
                                  >
                                    <div
                                      className="d-flex align-items-center"
                                      style={{
                                        fontSize: "13px",
                                        color: "#065f46",
                                      }}
                                    >
                                      <em className="icon ni ni-call mr-1"></em>
                                      Attached Number:&nbsp;
                                      <strong>
                                        {this.state.preAttachedTwilioNumber}
                                      </strong>
                                    </div>

                                    <div
                                      className="d-flex align-items-center"
                                      style={{ gap: "8px" }}
                                    >
                                      {/* âœ… Disabled Attached Button */}
                                      <button
                                        type="button"
                                        className="btn btn-success d-flex align-items-center"
                                        style={{
                                          height: "34px",
                                          fontWeight: 500,
                                          opacity: 0.8,
                                          cursor: "not-allowed",
                                        }}
                                        disabled
                                      >
                                        <em className="icon ni ni-check mr-1"></em>{" "}
                                        Attached
                                      </button>

                                      {/* âŒ Remove Button */}
                                      <button
                                        type="button"
                                        className="btn btn-outline-danger d-flex align-items-center"
                                        style={{
                                          height: "34px",
                                          fontWeight: 500,
                                        }}
                                        onClick={this.openRemoveNumberModal}
                                      >
                                        <em className="icon ni ni-cross mr-1"></em>{" "}
                                        Remove
                                      </button>
                                    </div>
                                  </div>
                                ) : (
                                  // âœ… Otherwise show the active "Attach Number" button
                                  <div className="mt-3 d-flex align-items-center">
                                    <button
                                      type="button"
                                      onClick={this.attachAgentNumber}
                                      disabled={
                                        this.state.isProcessingNumberAttach
                                      }
                                      className="btn btn-primary d-flex align-items-center"
                                      style={{
                                        height: "38px",
                                        fontWeight: 500,
                                      }}
                                    >
                                      {this.state.isProcessingNumberAttach ? (
                                        <>
                                          <em className="icon ni ni-loader animate-spin mr-1"></em>
                                          Attachingâ€¦
                                        </>
                                      ) : (
                                        <>
                                          <em className="icon ni ni-link-alt mr-1"></em>
                                          Attach Number
                                        </>
                                      )}
                                    </button>
                                  </div>
                                )}

                                <p
                                  className="text-muted mb-0 mt-3"
                                  style={{
                                    fontSize: "13px",
                                    lineHeight: "1.5",
                                  }}
                                >
                                  POST this data to your integration route (e.g.
                                  <code>
                                    {" "}
                                    https://chat.voiceadmins.com/api/telephony/call{" "}
                                  </code>
                                  ) to link the AI Agent and Twilio number.
                                </p>
                              </div>
                            )}
                          </div>
                        </div>

                        {/* === Attach with Sharelinks === */}
                        <div className="col-lg-12">
                          <div
                            className="card p-4"
                            style={{
                              border: "1px solid #e5e7eb",
                              borderRadius: "8px",
                              backgroundColor: disableSharelinks
                                ? "#f7f7f7"
                                : "#fff",
                              opacity: disableSharelinks ? 0.5 : 1,
                              pointerEvents: disableSharelinks
                                ? "none"
                                : "auto",
                            }}
                          >
                            <div
                              className="d-flex justify-content-between align-items-center"
                              style={{
                                cursor: disableSharelinks
                                  ? "not-allowed"
                                  : "pointer",
                              }}
                              onClick={() =>
                                !disableSharelinks &&
                                this.setState({
                                  showSharelinks: !this.state.showSharelinks,
                                })
                              }
                            >
                              <h6 className="fw-bold mb-0">
                                Attach with Sharelinks
                              </h6>
                              <em
                                className={`icon ni ${
                                  this.state.showSharelinks
                                    ? "ni-chevron-up"
                                    : "ni-chevron-down"
                                }`}
                              ></em>
                            </div>

                            {this.state.showSharelinks && (
                              <div className="mt-3">
                                {this.state.agentSharelinks &&
                                this.state.agentSharelinks.length > 0 ? (
                                  <>
                                    <p className="text-muted mb-2">
                                      Select one or more Sharelinks to connect
                                      this AI Agent.
                                    </p>

                                    <Select
                                      isMulti={false} // â¬…ï¸ Only ONE allowed now
                                      isClearable={true}
                                      closeMenuOnSelect={true}
                                      menuPortalTarget={document.body}
                                      styles={{
                                        menuPortal: (base) => ({
                                          ...base,
                                          zIndex: 99999,
                                        }),
                                        control: (base) => ({
                                          ...base,
                                          minHeight: "38px",
                                          borderColor: "#dcdcdc",
                                          boxShadow: "none",
                                          backgroundColor: "#fff",
                                          "&:hover": { borderColor: "#bfbfbf" },
                                        }),
                                      }}
                                      options={this.state.agentSharelinks}
                                      placeholder="Select Sharelink..."
                                      value={
                                        this.state.selectedSharelinks || null
                                      }
                                      onChange={(selected) =>
                                        this.setState({
                                          selectedSharelinks: selected
                                            ? [selected]
                                            : [], // SINGLE VALUE wrapped in array
                                        })
                                      }
                                    />
                                  </>
                                ) : (
                                  <p className="text-muted mb-0">
                                    No Sharelinks found.
                                  </p>
                                )}
                              </div>
                            )}
                          </div>
                        </div>

                        {/* === Attach with Clients === */}
                        <div className="col-lg-12">
                          <div
                            className="card p-4"
                            style={{
                              border: "1px solid #e5e7eb",
                              borderRadius: "8px",
                              backgroundColor: disableClients
                                ? "#f7f7f7"
                                : "#fff",
                              opacity: disableClients ? 0.5 : 1,
                              pointerEvents: disableClients ? "none" : "auto",
                            }}
                          >
                            <div
                              className="d-flex justify-content-between align-items-center"
                              style={{
                                cursor: disableClients
                                  ? "not-allowed"
                                  : "pointer",
                              }}
                              onClick={() =>
                                !disableClients &&
                                this.setState({
                                  showClients: !this.state.showClients,
                                })
                              }
                            >
                              <h6 className="fw-bold mb-0">
                                Attach with Clients
                              </h6>
                              <em
                                className={`icon ni ${
                                  this.state.showClients
                                    ? "ni-chevron-up"
                                    : "ni-chevron-down"
                                }`}
                              ></em>
                            </div>

                            {this.state.showClients && (
                              <div className="mt-3">
                                {this.state.clientList &&
                                this.state.clientList.length > 0 ? (
                                  <>
                                    <p className="text-muted mb-2">
                                      Select one or more Clients to link this AI
                                      Agent.
                                    </p>

                                    <Select
                                      isMulti={false} // â¬…ï¸ Only ONE allowed now
                                      isClearable={true}
                                      closeMenuOnSelect={true}
                                      menuPortalTarget={document.body}
                                      styles={{
                                        menuPortal: (base) => ({
                                          ...base,
                                          zIndex: 99999,
                                        }),
                                        control: (base) => ({
                                          ...base,
                                          minHeight: "38px",
                                          borderColor: "#dcdcdc",
                                          boxShadow: "none",
                                          "&:hover": { borderColor: "#bfbfbf" },
                                        }),
                                      }}
                                      options={this.state.clientList}
                                      placeholder="Select Client..."
                                      value={this.state.selectedClients || null}
                                      onChange={(selected) =>
                                        this.setState({
                                          selectedClients: selected
                                            ? [selected]
                                            : [], // SINGLE VALUE wrapped in array
                                        })
                                      }
                                    />
                                  </>
                                ) : (
                                  <p className="text-muted mb-0">
                                    No Clients found.
                                  </p>
                                )}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* === Footer === */}
                    <div
                      className="modal-footer d-flex justify-content-between align-items-center"
                      style={{
                        borderTop: "1px solid #e5e7eb",
                        paddingTop: "15px",
                      }}
                    >
                      <button
                        className="btn btn-light"
                        onClick={() =>
                          window.$("#modalAgentActions").modal("hide")
                        }
                      >
                        Close
                      </button>

                      <button
                        type="button"
                        className="btn btn-primary d-flex align-items-center"
                        style={{ height: "38px", fontWeight: 500 }}
                        disabled={this.state.isProcessingAttach}
                        onClick={this.attachAgentSharelinks}
                      >
                        {this.state.isProcessingAttach ? (
                          <>
                            <em className="icon ni ni-loader mr-1 animate-spin"></em>{" "}
                            Updatingâ€¦
                          </>
                        ) : (
                          <>
                            <span>Attach</span>
                            <em
                              className="icon ni ni-link-alt ml-1"
                              style={{ fontSize: "15px" }}
                            ></em>
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal fade" tabIndex="-1" id="modalRemoveNumber">
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <a
                      style={{ cursor: "pointer" }}
                      className="close"
                      onClick={() => this.closeRemoveNumberModal()}
                    >
                      <em className="icon ni ni-cross"></em>
                    </a>
                    <div className="modal-body modal-body-lg text-center">
                      <div className="nk-modal">
                        <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-alert bg-warning"></em>

                        <h5
                          className="nk-modal-title mt-3"
                          style={{
                            fontSize: "1.25rem",
                            color: "#1f2937",
                            fontWeight: 600,
                            lineHeight: "1.5",
                          }}
                        >
                          Are you sure you want to remove this Twilio number?
                        </h5>

                        <div className="nk-modal-text">
                          {/* {this.state.errorMessageAttach && (
                            <div className="example-alert mb-3">
                              <div className="alert alert-pro alert-danger">
                                <div className="alert-text">
                                  <h4>Error</h4>
                                  <p>{this.state.errorMessageAttach}</p>
                                </div>
                              </div>
                            </div>
                          )}
                          {this.state.successMessageAttach && (
                            <div className="example-alert mb-3">
                              <div className="alert alert-pro alert-success">
                                <div className="alert-text">
                                  <h4>Success</h4>
                                  <p>{this.state.successMessageAttach}</p>
                                </div>
                              </div>
                            </div>
                          )} */}
                        </div>

                        <div className="nk-modal-action">
                          <a
                            style={{ cursor: "pointer", color: "white" }}
                            className="btn btn-lg btn-mw btn-primary"
                            onClick={() => this.closeRemoveNumberModal()}
                          >
                            CANCEL
                          </a>
                          {"  "}
                          <button
                            style={{ cursor: "pointer" }}
                            className="btn btn-lg btn-mw btn-danger"
                            onClick={() => this.removeAgentNumber()}
                            disabled={this.state.isRemovingNumber}
                          >
                            {this.state.isRemovingNumber
                              ? "REMOVING..."
                              : "REMOVE"}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* === ACTION SELECTION MODAL === */}
              <div
                className="modal fade"
                id="modalNoAgent"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="modalNoAgentLabel"
                aria-hidden="true"
              >
                <div
                  className="modal-dialog modal-dialog-centered"
                  role="document"
                >
                  <div
                    className="modal-content text-center p-4"
                    style={{ borderRadius: "10px" }}
                  >
                    <div className="modal-body">
                      <em
                        className="icon ni ni-alert-circle text-warning"
                        style={{ fontSize: "40px", marginBottom: "10px" }}
                      ></em>
                      <h5 className="modal-title mb-2" id="modalNoAgentLabel">
                        Agent Not Available
                      </h5>
                      <p
                        className="text-muted mb-3"
                        style={{ fontSize: "14px", lineHeight: "1.5" }}
                      >
                        {this.state.inactiveAgentMessage ||
                          "No AI Agent found for this form."}
                      </p>
                      <button
                        type="button"
                        className="btn btn-primary"
                        data-dismiss="modal"
                        style={{ height: "38px", fontWeight: 500 }}
                      >
                        OK, Got It
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    defaultSettings: state.settings,
    is_msa_signed: state.is_msa_signed,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    addSettings: (payload) => dispatch(addSettings(payload)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(FormSubmit);
